// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep .cdk-overlay-pane {
    height: auto !important;
    overflow: hidden !important;
}


/* .mat-dialog-actions {
    border-top: 1px solid #cdcdcd;
    margin-top: 30px;
    display: inherit !important;
    padding: 1.5rem 0 !important;
} */

::ng-deep .mat-dialog-container {
    overflow: hidden !important;
    height: 100%;
}

::ng-deep .advanced-search-input .md-drppicker.drops-true-auto {
    top: auto !important;
    left: auto !important;
    right: auto !important;
    position: initial !important;
    margin-bottom: 10px;
}

::ng-deep .advanced-search-input .md-drppicker.drops-down-auto {
    top: auto !important;
    left: auto !important;
    right: auto !important;
    position: initial !important;
    margin-bottom: 10px;
}

::ng-deep .advanced-search-input .md-drppicker td.active,
.advanced-search-input .md-drppicker td.active:hover {
    background-color: #008fc7 !important;
}

::ng-deep .advanced-search-input .md-drppicker .btn {
    background-color: #008fc7 !important;
    padding: 0 15px !important;
}

::ng-deep .advanced-search-input .calendar.left {
    width: 50%;
    margin-bottom: 45px;
}

::ng-deep .advanced-search-input .calendar.right {
    width: 50%;
    margin-bottom: 45px;
}

::ng-deep .advanced-search-input .md-drppicker .buttons {
    position: absolute;
    bottom: 0;
    right: 12%;
}
`, "",{"version":3,"sources":["webpack://./src/app/catalog/advance-search-dialog/advance-search-dialog.component.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,2BAA2B;AAC/B;;;AAGA;;;;;GAKG;;AAEH;IACI,2BAA2B;IAC3B,YAAY;AAChB;;AAEA;IACI,oBAAoB;IACpB,qBAAqB;IACrB,sBAAsB;IACtB,4BAA4B;IAC5B,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,qBAAqB;IACrB,sBAAsB;IACtB,4BAA4B;IAC5B,mBAAmB;AACvB;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;IACpC,0BAA0B;AAC9B;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;AACd","sourcesContent":["::ng-deep .cdk-overlay-pane {\r\n    height: auto !important;\r\n    overflow: hidden !important;\r\n}\r\n\r\n\r\n/* .mat-dialog-actions {\r\n    border-top: 1px solid #cdcdcd;\r\n    margin-top: 30px;\r\n    display: inherit !important;\r\n    padding: 1.5rem 0 !important;\r\n} */\r\n\r\n::ng-deep .mat-dialog-container {\r\n    overflow: hidden !important;\r\n    height: 100%;\r\n}\r\n\r\n::ng-deep .advanced-search-input .md-drppicker.drops-true-auto {\r\n    top: auto !important;\r\n    left: auto !important;\r\n    right: auto !important;\r\n    position: initial !important;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n::ng-deep .advanced-search-input .md-drppicker.drops-down-auto {\r\n    top: auto !important;\r\n    left: auto !important;\r\n    right: auto !important;\r\n    position: initial !important;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n::ng-deep .advanced-search-input .md-drppicker td.active,\r\n.advanced-search-input .md-drppicker td.active:hover {\r\n    background-color: #008fc7 !important;\r\n}\r\n\r\n::ng-deep .advanced-search-input .md-drppicker .btn {\r\n    background-color: #008fc7 !important;\r\n    padding: 0 15px !important;\r\n}\r\n\r\n::ng-deep .advanced-search-input .calendar.left {\r\n    width: 50%;\r\n    margin-bottom: 45px;\r\n}\r\n\r\n::ng-deep .advanced-search-input .calendar.right {\r\n    width: 50%;\r\n    margin-bottom: 45px;\r\n}\r\n\r\n::ng-deep .advanced-search-input .md-drppicker .buttons {\r\n    position: absolute;\r\n    bottom: 0;\r\n    right: 12%;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
